import React from "react";
import BlogDetail from "./BlogDetail";
import GetInTouchSide from "./GetInTouchSide";
import useProfile from "../customHooks/useProfile";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../axiosStrapi";

const StudentProfile = () => {
  const {userDetails}=useProfile();
  const navigate=useNavigate();
  return (
    <div className="font-Lato mx-auto h-[calc(100vh-80px)] flex lg:flex-row flex-col">
      {/* Header Section */}
      <div className="lg:w-[70%] border-r h-[100%] pl-[10%] pr-[5%] py-[5%] border-[#C2C2C2]">
        {" "}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div style={{ display: "flex", gap: "15px" }}>
            <img
              src={`${userDetails?.image?.url}`}
              alt="Profile"
              style={{
                width: "88px",
                height: "88px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "10px solid #FDBE60",
              }}
            />
            <div>
              <h1 className="m-0 text-[36px] text-black leading-[40px] font-medium ">
                {userDetails?.fullName}
              </h1>
              <p className="m-0 text-black text-base leading-5 font-medium ">
                {userDetails?.class?.class}{" "}
                {userDetails?.class?.section}
              </p>
            </div>
          </div>
          <button
            style={{
              backgroundColor: "#D31C4F",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "12px",
              cursor: "pointer",
              fontSize: "16px",
              textAlign: "center",
              lineHeight: "28px",
            }}
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
          >
            Log out
          </button>
        </div>
        {/* Profile Details Section */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "30px 20px",
            marginTop: "30px",
          }}
        >
          {[
            { field: "fullName", label: "Full Name" },
            { field: "age", label: "Age" },
            { field: "gender", label: "Gender" },
            { field: "class", label: "Class" },
            { field: "rollNo", label: "Roll No." },
            { field: "admissionNumber", label: "Admission No." },
            { field: "phone", label: "Contact no." },
            { field: "email", label: "Email Address" },
          ].map((item, index) => (
            <div key={index}>
              <label
                style={{
                  display: "block",
                  fontSize: "16px",
                  marginBottom: "5px",
                  color: "black",
                  fontWeight: 400,
                  lineHeight: "20px",
                }}
              >
                {item.label}
              </label>
              <input
                type="text"
                value={
                  item?.field === "class"
                    ? `${userDetails?.class?.class}` +
                      `${
                        userDetails?.section
                          ? userDetails?.section?.section
                          : ""
                      }`
                    : userDetails[item.field]
                }
                readOnly
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "16px",
                  color: "black",
                  backgroundColor: "#CCCCCC",
                  borderRadius: "5px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  outline: "none",
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="lg:w-[30%]">
        <GetInTouchSide />
      </div>
    </div>
  );
};

export default StudentProfile;
